import { Component} from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  //Services
  services = [
    {
      icon: 'bi-braces',
      title: 'Coding',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    },
    {
      icon: 'bi-globe',
      title: 'Development',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    },
    {
      icon: 'bi-droplet',
      title: 'Marketing',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    },
    {
      icon: 'bi-highlighter',
      title: 'Angular Development',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    },
    {
      icon: 'bi-rocket-takeoff',
      title: '3d Animation',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    },
    {
      icon: 'bi-laptop',
      title: 'Responsive',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa.'
    }
  ];
  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
